import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { VehicleRoadWorthyCheckStatusEnum } from '../enums/vehicle-road-worthy-check-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function vehicleRoadWorthyCheckStatusToColor(
	status: VehicleRoadWorthyCheckStatusEnum,
): string {
	switch (status) {
		case VehicleRoadWorthyCheckStatusEnum.PENDING:
			return RecordColorEnum.AMBER;

		case VehicleRoadWorthyCheckStatusEnum.ACTIVE:
			return RecordColorEnum.GREEN;

		case VehicleRoadWorthyCheckStatusEnum.EXPIRED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
